import React from 'react';
import { Box } from '@chakra-ui/react';
import c2pBackground from '../../common/assets/clik2pay_background_image.svg';
import PropTypes from 'prop-types';

const BackgroundWrapper = ({
                             children,
                             ...props }) => {
  return (
    <Box
      backgroundImage={`url(${c2pBackground})`}
      backgroundRepeat="no-repeat"
      backgroundSize="contain"
      backgroundPosition="left bottom"
      minHeight="100vh"
      {...props}
    >
      {children}
    </Box>
  );
};

BackgroundWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired,
};

export default BackgroundWrapper;
